<template>
    <div class="container-fluid py-4">
      <!-- Header -->
      <div class="row mb-4">
        <div class="col-12">
          <div class="align-items-center">
            <button class="btn btn-secondary" @click="cancelar">
                Regresar
            </button>
          </div>
          <div class="align-items-center">
           <center> <h2 class="mb-0">Nueva Receta</h2></center>
          </div>
        </div>
      </div>
  
      <!-- Main Card -->
      <div class="row">
        <div class="col-lg-8 col-xl-6 mx-auto">
          <div class="card shadow-sm">
            <div class="card-header">
              <h6 class="mb-0">Paso 1: Seleccionar Producto</h6>
            </div>
            <div class="card-body">
              
              <!-- Scanner de Producto Principal -->
              <SearchProductoComponent
                v-model="productoSeleccionado"
                @error="manejarError"
                ref="scannerInput"
              />
  
              <!-- Producto Encontrado -->
              <div v-if="productoSeleccionado" class="mb-4">
                <div class="alert alert-success d-flex justify-content-between align-items-center">
                  <div>
                    <i class="bi bi-check-circle me-2"></i>
                    <strong>Producto encontrado:</strong>
                    <div class="mt-2">
                      <div class="fw-bold">{{ productoSeleccionado.nombre }}</div>
                      <small class="text-muted">SKU: {{ productoSeleccionado.sku }}</small>
                    </div>
                  </div>
                  <button 
                    class="btn btn-sm btn-outline-danger" 
                    @click="limpiarProducto"
                    title="Cambiar producto"
                  >
                    <i class="fas fa-trash"></i>
                  </button>
                </div>
                <span v-if="errors && errors.producto" class="text-danger">{{ errors.producto }}</span>
                <div class="form-group">
                  <label for="inputFechaInicio">Fecha de Inicio:</label>
                  <input 
                    type="date" 
                    class="form-control" 
                    id="inputFechaInicio"
                    v-model="receta.fecha_inicio"
                    :min="diaSiguiente"
                    @change="validarFechas"
                  >
                </div>

                <div class="form-group">
                  <label for="inputFechaFin">Fecha de Fin:</label>
                  <input 
                    type="date" 
                    class="form-control" 
                    id="inputFechaFin"
                    v-model="receta.fecha_fin"
                    :min="minFechaFin"
                    @change="validarFechas"
                  >
                </div>
              </div>
  
              <!-- Mensaje de error -->
              <div v-if="errorBusqueda" class="alert alert-danger">
                <i class="fas fa-exclamation-triangle me-2"></i>
                {{ errorBusqueda }}
              </div>
  
              <!-- Campos adicionales (habilitados después de seleccionar producto) -->
              <div class="row m-2" v-if="productoSeleccionado">
                <!-- Botón Guardar -->
                <div class="m-1">
                  <button 
                    class="btn btn-sm btn-success btn-lg" 
                    @click="guardarEncabezado(false)"
                    :disabled="guardando"
                  >
                    <span v-if="guardando">
                      <span class="spinner-border spinner-border-sm me-2"></span>
                      Guardando...
                    </span>
                    <span v-else>
                      Guardar y Agregar nuevo
                      <i class="fas fa-arrow-right ms-2"></i>
                    </span>
                  </button>
                </div>
                <div class="m-1">
                  <button 
                    class="btn btn-sm btn-success btn-lg" 
                    @click="guardarEncabezado(true)"
                    :disabled="guardando"
                  >
                    <span v-if="guardando">
                      <span class="spinner-border spinner-border-sm me-2"></span>
                      Guardando...
                    </span>
                    <span v-else>
                      Guardar y Editar
                      <i class="fas fa-arrow-right ms-2"></i>
                    </span>
                  </button>
                </div>
              </div>
  
              <!-- Instrucciones iniciales -->
              <div v-else class="text-center text-muted py-5">
                <i class="fas fa-search fs-1 d-block mb-3 opacity-50"></i>
                <p class="mb-0">Escanee el código de barras del producto para comenzar</p>
              </div>
  
            </div>
          </div>
  
          <!-- Información adicional -->
          <div v-if="productoSeleccionado" class="card shadow-sm mt-3">
            <div class="card-body">
              <small class="text-muted">
                <i class="bi bi-info-circle me-1"></i>
                Después de guardar, podrá agregar los ingredientes necesarios para la receta.
              </small>
            </div>
          </div>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import RecetaService from "@/services/catalogos/RecetaService";
  import Notifications from "@/notifications/notifications";
  import DynamicService from "@/services/commons/DynamicService";
  import SearchProductoComponent from "@/components/commons/SearchProductoComponent.vue";

  import { formatearMensaje } from "@/utils";

  export default {
    components: {
      SearchProductoComponent
    },
    data() {
      return {
        codigoBarras: '',
        errorBusqueda: '',
        guardando: false,
        productoSeleccionado:null,
        receta: {
          producto: null,
          fecha_inicio:null,
          fecha_fin:null,
        },
        errors:[],
        costoValidado:false,
        precioValidado: false,
      };
    },
    watch: {
      productoSeleccionado(newValue) {
        if (newValue!= null) {
          if(!newValue.activo){
            this.$toast.error( "El producto seleccionado no está activo.","Error", {
              position: 'topRight'
            });
            this.limpiarProducto();
          }
        }else {
          this.limpiarProducto();
        }
      },
    },
    computed: {
      // Formato YYYY-MM-DD necesario para el input type="date"
      diaSiguiente() {
        const hoy = new Date();
        hoy.setDate(hoy.getDate() + 1);
        return hoy.toISOString().split('T')[0];
      },
      // La fecha fin no puede ser menor que la fecha inicio ni menor que hoy
      minFechaFin() {
        if (this.receta.fecha_inicio && this.receta.fecha_inicio > this.diaSiguiente) {
          return this.receta.fecha_inicio;
        }
        return this.diaSiguiente;
      },
      preciosValidados(){
        return this.costoValidado && this.precioValidado;
      },
      precioMenor(){
        return parseFloat(this.receta.precio) <= parseFloat(this.receta.costo);
      }
    },
    mounted() {
      this.$nextTick(() => {
        this.$refs.scannerInput.focus();
      });
    },
    methods: {
  
      limpiarProducto() {
        this.productoSeleccionado = null;
        this.receta.producto = "";
        this.receta.fecha_inicio = null;
        this.receta.fecha_fin = null;
        this.codigoBarras = '';
        this.errorBusqueda = '';
        this.errors = [];
        
        this.$nextTick(() => {
          this.$refs.scannerInput.focus();
        });
      },
      validarFechas() {
        // Ajusta la fecha fin automáticamente si queda inconsistente al cambiar fecha inicio
        if (this.receta.fecha_inicio < this.diaSiguiente) {
          this.receta.fecha_inicio = this.diaSiguiente;
        }
        if (this.receta.fecha_fin && this.receta.fecha_fin < this.minFechaFin) {
          this.receta.fecha_fin = this.minFechaFin;
        }
      },
      validar(){
        // Validaciones
        if (!this.productoSeleccionado) {
          Notifications.alert.error('Error','Debe seleccionar un producto');
          return;
        }

        this.costoValidado = false;
        this.precioValidado = false;
  
        if (!this.receta.costo || this.receta.costo == null || this.receta.costo == undefined || this.receta.costo == 0) {
          this.costoValidado =true;
        }
        if (!this.receta.precio || this.receta.precio == null || this.receta.precio == undefined || this.receta.precio == 0) {
          this.precioValidado = true;
        }

      },
      async guardarEncabezado(editar=false) {

        this.guardando = true;
        this.receta.producto = this.productoSeleccionado.sku;
        this.receta.precio = parseFloat(0);
        this.receta.costo = parseFloat(0);
      
        // Simular llamada API
        RecetaService.save(this.receta)
        .then(response => {
          let recetae = response.data;
          let msj = `Receta ${recetae.numero} guardada con éxito.`;
          this.$toast.success(msj, "Éxito", {
            position: 'topRight'
          });
          if (editar) {
            this.$router.push({
              name: 'cat-receta-editar',
              params: { id: recetae.id }
            });
          }
          else {
            
          this.limpiarProducto();
          }
        })
        .catch(error => {
          console.error('Error al guardar:', error.response.data);
          this.errors = error.response.data
          let res = formatearMensaje(error.response.data)
          this.$toast.warning( res, "Error",{
            position: 'topRight'
          });
        })
        .finally(() => {
          this.guardando = false;
        })
      },
  
      cancelar() {
        Notifications.alert.confirm(
          'Cancelar',
          '¿Está seguro de cancelar? Se perderán los datos ingresados.',
          "Sí",
          ()=>{
            this.$router.push({ name: 'cat-recetas' });
          }
        ) 
      },
    manejarError(mensaje) {
      this.errorBusqueda = mensaje;
      // Opcional: limpiar el error después de un tiempo
      setTimeout(() => {
        this.errorBusqueda = null;
      }, 5000);
    }
    }
  };
  </script>
  
  <style scoped>
  .input-group-lg .input-group-text {
    font-size: 1.5rem;
  }
  
  .alert {
    border-radius: 0.5rem;
  }
  </style>